import { main, auth, signUp } from "../constants/actionTypes";

const defaultState = {
  client: false,
  countries: null,
  error: null,
  language: 1,
  isLoggedIn: null,
  // Set when the member is signed in but the backend has no account for the identity (GROWTH-7362).
  accountUnavailable: null,
  notifications: [],
  practices: null,
  preloaders: {
    verifyEmailCode: null,
    notifications: false
  },
  states: null,
  verifyEmailCode: {
    verifyCodeSend: null,
    verifyCodeCheck: null,
    verifyCodeStatus: false,
    token: "",
    email: ""
  },
  paymentError: {
    isActive: false,
    errorMessage: ""
  },
  isActiveNewListing: false,
  listingModalListingType: "",
  isActiveMobileMenu: false,
  footerInfo: [],
  socialLinks: [],
  communities: []
};

export default function(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case main.GET_FOOTER_INFO: {
      return {
        ...state,
        footerInfo: payload.footerInfo,
        socialLinks: payload.socialLinks,
        preloaders: {
          ...state.preloaders,
          footerInfo: false
        }
      };
    }

    case main.GET_FOOTER_INFO_FAIL:
      return {
        ...state,
        error: payload,
        preloaders: {
          ...state.preloaders,
          footerInfo: false
        }
      };

    case main.GET_UTILITY_LISTING: {
      return {
        ...state,
        ...payload,
        preloaders: {
          ...state.preloaders,
          notifications: false,
          utilityListing: false
        }
      };
    }

    case main.GET_UTILITY_LISTING_FAIL:
      return {
        ...state,
        error: payload,
        preloaders: {
          ...state.preloaders,
          notifications: false,
          utilityListing: false
        }
      };

    case main.SET_LOADING:
      return {
        ...state,
        preloaders: { ...state.preloaders, [payload.section]: payload.isSectionLoading }
      };

    case auth.SET_SUCCESS:
    case auth.LOGIN_SUCCESS:
    case signUp.SET_SUCCESS:
    case main.GET_LOGIN:
    case main.GET_LOGIN_FAIL:
      return {
        ...state,
        // eslint-disable-next-line no-prototype-builtins
        isLoggedIn: payload.hasOwnProperty("ok") ? payload.ok : payload
      };

    case auth.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        accountUnavailable: null
      };

    case auth.ACCOUNT_UNAVAILABLE:
      // The first refusal is kept: every request the member area has in flight is refused the same way.
      if (state.accountUnavailable) {
        return state;
      }

      return {
        ...state,
        accountUnavailable: { requestId: payload?.requestId || null }
      };

    case auth.SET_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: payload
      };

    case main.SEND_EMAIL_VERIFY_CODE_SUCCESS:
      return {
        ...state,
        verifyEmailCode: {
          ...state.verifyEmailCode,
          verifyCodeSend: true,
          token: payload?.token || "",
          email: payload?.email || ""
        }
      };

    case main.SEND_EMAIL_VERIFY_CODE_FAIL:
      return {
        ...state,
        verifyEmailCode: {
          ...state.verifyEmailCode,
          verifyCodeSend: false,
          token: "",
          email: ""
        }
      };

    case main.CHECK_EMAIL_VERIFY_CODE_SUCCESS:
      return {
        ...state,
        verifyEmailCode: {
          ...state.verifyEmailCode,
          verifyCodeCheck: true,
          token: "",
          email: ""
        },
        preloaders: {
          ...state.preloaders,
          verifyEmailCode: false
        }
      };

    case main.CHECK_EMAIL_VERIFY_CODE_FAIL:
      return {
        ...state,
        verifyEmailCode: {
          ...state.verifyEmailCode,
          verifyCodeCheck: false
        },
        preloaders: {
          ...state.preloaders,
          verifyEmailCode: false
        }
      };

    case main.TOGGLE_PAYMENT_ERROR:
      return {
        ...state,
        paymentError: {
          isActive: payload.isActive,
          errorMessage: payload.errorMessage
        }
      };

    case main.TOGGLE_NEW_LISTING:
      return {
        ...state,
        isActiveNewListing: payload.isActive,
        listingModalListingType: payload.listingType
      };

    case main.TOGGLE_MOBILE_MENU:
      return {
        ...state,
        isActiveMobileMenu: payload.isActive
      };

    case main.GET_COMMUNITIES:
      return {
        ...state,
        communities: payload,
        preloaders: {
          ...state.preloaders,
          communities: false
        }
      };

    default:
      return state;
  }
}
